export const customerKey = {
  all: ['customer'] as const,
  get: () => [...customerKey.all, 'get'] as const,
};
